"use strict";var e=require("react"),t=require("@cko/primitives"),l=require("styled-components");function a(e){return e&&e.__esModule?e:{default:e}}var r=a(e),n=a(l);const i=n.default(t.Flex)`
  gap: var(--layout-soybean);
  align-items: center;
  align-self: stretch;
  margin-top: var(--layout-seed);
`,u=n.default(t.Flex)`
  min-width: 36px;
`,f=n.default(t.Flex)`
  align-items: start;
  justify-content: center;
  min-width: 80px;
`,d=({title:e,prefix:l,suffix:a})=>r.default.createElement(i,null,l&&r.default.createElement(u,null,l),e&&r.default.createElement(t.TextHeadingTwo,null,e),a&&r.default.createElement(f,null,a," ")),c=n.default(t.Flex)`
  gap: var(--layout-spoon);
  align-items: center;
  align-self: stretch;
`,o=n.default(t.Flex)`
  min-width: 26px;
`,s=n.default(t.Flex)`
  min-width: 26px;
`,m=({description:e,prefix:l,suffix:a})=>r.default.createElement(c,null,l&&r.default.createElement(o,null,l),e&&r.default.createElement(t.Text,null,e),a&&r.default.createElement(s,null,a)),x=n.default(t.Flex)`
  flex-direction: row;
  gap: var(--layout-spoon);
  align-items: top;
  justify-content: space-between;
  justify-self: strech;

  width: 100%;
`,p=n.default(t.Flex)`
  flex-direction: column;
  gap: var(--layout-seed);
`,y=n.default(t.Flex)`
  flex-direction: column;
`,g=({children:e,title:t,description:l,titlePrefix:a,titleSuffix:n,descriptionPrefix:i,descriptionSuffix:u})=>r.default.createElement(x,null,r.default.createElement(p,null,r.default.createElement(d,{title:t,suffix:n,prefix:a}),l&&r.default.createElement(m,{description:l,suffix:u,prefix:i})),e&&r.default.createElement(y,null,e)),E=n.default(t.Flex)`
  flex-direction: column;
  gap: var(--layout-spoon);
  align-items: stretch;
  align-self: stretch;
`,h=n.default(t.Flex)`
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`,v=n.default(t.Text)`
  font: var(--body-xs);
  color: var(--base-text-secondary);
`,F=n.default(t.Flex)`
  flex-direction: row;
  gap: var(--layout-shoebox);
`,w=n.default(t.Divider)`
  height: 44px;
`;exports.SecondaryHeader=({children:e,userActions:t,...l})=>r.default.createElement(E,null,r.default.createElement(g,l,t),e),exports.SecondaryHeaderSummary=({children:e})=>r.default.createElement(F,null,!Array.isArray(e)&&e,Array.isArray(e)&&e.map(((t,l)=>r.default.createElement(r.default.Fragment,{key:l},t,l<e.length-1&&r.default.createElement(w,{orientation:"vertical"}))))),exports.SummaryItem=({label:e,children:t})=>r.default.createElement(h,null,r.default.createElement(v,null,e),t);
//# sourceMappingURL=index.cjs.map
